import { createReducer } from '@common/utils/redux';

export type DatasheetFormatPreferenceState = {
  byContext: Record<string, number | undefined>;
};

const initialState: DatasheetFormatPreferenceState = {
  byContext: {},
};

const SET_FORMAT_PREFERENCE = 'datasheets/SET_FORMAT_PREFERENCE';

export const setDatasheetFormatPreference = (contextKey: string, formatId: number | undefined) => ({
  type: SET_FORMAT_PREFERENCE,
  payload: { contextKey, formatId },
});

export const datasheetFormatPreferenceReducer = createReducer(initialState, {
  [SET_FORMAT_PREFERENCE]: (
    state: DatasheetFormatPreferenceState,
    payload: { contextKey: string; formatId: number | undefined }
  ) => ({
    ...state,
    byContext: {
      ...state.byContext,
      [payload.contextKey]: payload.formatId,
    },
  }),
});

export const selectDatasheetFormatPreference = (
  state: { datasheetFormatPreference?: DatasheetFormatPreferenceState },
  contextKey: string
): number | undefined => state.datasheetFormatPreference?.byContext?.[contextKey];
